import { useDispatch, useSelector } from 'react-redux'

import { selectProjectConfig } from '@store/actionSlices/projectConfig'
import {
  addShortlist,
  filterShortlist,
  selectShortlist,
} from '@store/actionSlices/shortlist'
import { ShortlistPropertyType } from '@store/types'

import { notifyError } from '@adUtilities/notifier'
import { Unit } from '@adUtilities/types/apartment'

import { MAXIMUM_PROPERTY_LENGTH_FOR_SHORTLIST } from './constants'

const useUnitShortlist = () => {
  const dispatch = useDispatch()
  const { shortlists } = useSelector(selectShortlist)
  const { statusLabels } = useSelector(selectProjectConfig)

  const isUnitShortlisted = (unit: Unit) =>
    shortlists.some((shortlist) => shortlist.propertyId === unit.id)

  const toggleUnitShortlist = (unit: Unit) => {
    if (isUnitShortlisted(unit)) {
      dispatch(
        filterShortlist({
          propertyId: unit.id,
          type: ShortlistPropertyType.Unit,
        })
      )
      return
    }

    if (unit.metas.status !== statusLabels?.available) {
      notifyError(
        'This unit is not available, you can only shortlist available unit.'
      )
      return
    }

    if (shortlists.length >= MAXIMUM_PROPERTY_LENGTH_FOR_SHORTLIST) {
      notifyError(
        `You can shortlist a maximum of ${MAXIMUM_PROPERTY_LENGTH_FOR_SHORTLIST} units.`
      )
      return
    }

    dispatch(
      addShortlist({
        propertyId: unit.id,
        propertyName: unit.name,
        references: {
          blockId: unit.blockId,
          levelId: unit.metas.level,
        },
        type: ShortlistPropertyType.Unit,
      })
    )
  }

  return { isUnitShortlisted, toggleUnitShortlist }
}

export default useUnitShortlist
